module.exports = __webpack_public_path__ + "static/media/img-section-2.857df310.jpg";